(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlRadio', [])
        .directive('dynamicRadio', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-radio/custom-control-radio-template.html',
                controller: [
                    '$scope', function ($scope) {
                    }
                ]
            };
        });
})();